<!--    Map Container-->
<div class="grid mx-0" style="width: 100%; height: 100%">
  <div id="map-events-actions" class="map" leaflet 
       (leafletMapReady)="onMapReady($event)"
       [leafletOptions]="options"
       [leafletLayers]="markers">
  </div>
</div>
